import type { ProjectRole } from '@bigint-project/cloud-contracts';
import type { TaskCollaborationPort } from '@desktop/platform/ports';

import type { CloudApi } from '../api/client';

interface CloudCollaborationOptions {
  readonly api: CloudApi;
  readonly projectId: string;
  readonly role: ProjectRole;
  readonly currentUserId: string;
}

/** 把雲端 API 包成共用面板要的 port；Viewer 只讀，owner 可刪別人的內容。 */
export function createCloudCollaborationPort({
  api,
  projectId,
  role,
  currentUserId,
}: CloudCollaborationOptions): TaskCollaborationPort {
  return {
    currentUserId,
    canWrite: role !== 'viewer',
    isOwner: role === 'owner',
    summary: () => api.getCollaborationSummary(projectId),
    listComments: (taskId) => api.listTaskComments(projectId, taskId),
    addComment: (taskId, body) => api.createTaskComment(projectId, taskId, body),
    deleteComment: (taskId, commentId) => api.deleteTaskComment(projectId, taskId, commentId),
    listAttachments: (taskId) => api.listTaskAttachments(projectId, taskId),
    uploadAttachment: (taskId, file) => api.uploadTaskAttachment(projectId, taskId, file),
    attachmentDownloadUrl: (taskId, attachmentId) =>
      api.taskAttachmentDownloadUrl(projectId, taskId, attachmentId),
    deleteAttachment: (taskId, attachmentId) =>
      api.deleteTaskAttachment(projectId, taskId, attachmentId),
  };
}
